/* global axios */
import ApiClient from './ApiClient';

class PipelineAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  // Le fasi sono annidate sotto la pipeline: /pipelines/:pipelineId/stages
  createStage(pipelineId, stage) {
    return axios.post(`${this.url}/${pipelineId}/stages`, { stage });
  }

  updateStage(pipelineId, stageId, stage) {
    return axios.patch(`${this.url}/${pipelineId}/stages/${stageId}`, {
      stage,
    });
  }

  deleteStage(pipelineId, stageId, moveDealsToStageId = null) {
    return axios.delete(`${this.url}/${pipelineId}/stages/${stageId}`, {
      params: moveDealsToStageId
        ? { move_deals_to_stage_id: moveDealsToStageId }
        : {},
    });
  }

  reorderStages(pipelineId, stageIds) {
    return axios.patch(`${this.url}/${pipelineId}/stages/reorder`, {
      stage_ids: stageIds,
    });
  }
}

export default new PipelineAPI();
